import React from 'react';
import styled from 'styled-components';
import { colors, theme } from 'theme';
import { useSelector } from 'react-redux';
const Wrapper = styled.div`
	background-color: ${colors.surfaces.alternate};
	border-radius: ${theme.borderRadius.mdlg};
	padding: ${({ isMobile }) =>
		isMobile ? theme.padding.smmd : theme.padding.lg};
`;

export function AVCard({ children, style, className }) {
	const isMobile = useSelector((state) => state.ui.isMobile);
	return (
		<Wrapper isMobile={isMobile} className={className} style={style}>
			{children}
		</Wrapper>
	);
}
